export const OPERATOR_PROFILE_REVIEWS_STATUS = {
  IDLE: "idle",
  PENDING: "pending",
  SUCCEEDED: "succeeded",
  FAILED: "failed"
} as const;

export type ProfileReviewsStatus =
  (typeof OPERATOR_PROFILE_REVIEWS_STATUS)[keyof typeof OPERATOR_PROFILE_REVIEWS_STATUS];
